import { Gender } from 'common-constants/api6.types'

export interface Photo {
  albumId: number
  canDefault: boolean
  commentsCount: number
  default: boolean
  erotic: boolean
  height: number
  hugePhotoUrl: string
  id: number
  // Тоже самое что и id. Добавляем сами.
  photoId: number
  isRatingRejected: boolean
  isReject: boolean
  largePhotoUrl: string
  likesCount: number
  mediumPhotoUrl: string
  name: string
  ratingId: number
  smallPhotoUrl: string
  squareLargePhotoUrl: string
  squarePhotoUrl: string
  squareSmallPhotoUrl: string
  status: ModerationStatus
  verified: false
  votedByUser: false
  width: number
  thumbnail?: string
}

interface Album {
  canDeleted: boolean
  commentState: boolean
  coverUrl: string
  current: null
  default: boolean
  enable: boolean
  id: number
  isSystem: boolean
  name: ModerationStatus
  newCommentsAllowed: null
  pendingPhotos: Photo[]
  photoCounts: number
  photos: Photo[]
  updated: string
  visibleState: string
}

interface Online {
  online: boolean
  status: string
}

interface ProfileAttach {
  albumsCount: number
  gender: Gender
  id: number
  incognitoCanView: boolean
  incognitoIsOn: boolean
  login: string
  name: string
  newYearPhotoFrameEnabled: boolean
  newYearThemeSet: boolean
  onlineStatus: Online
  photo: {}
  photosCount: number
  smallPhotoUrl: string
  squarePhotoUrl: string
}

export interface FetchAlbumAttachPhotos {
  album: Album
  anketa: ProfileAttach
  maxPhotosInAlbum: number
  maxPhotosMessage: number
}

export enum ModerationStatus {
  approved = 'approved',
  pending = 'pending',
  rejected = 'rejected',
}

export type CustomPhoto = {
  photoId: number
  squareSmallPhotoUrl: string
  hugePhotoUrl: string
}

export type AttachPhotosType = CustomPhoto[]
